import { get } from 'lodash';
import { APP_SETTINGS_VERSION_0, APP_SETTINGS_VERSION_1, APP_SETTINGS_VERSION_2, APP_SETTINGS_VERSION_3, APP_SETTINGS_VERSION_LATEST } from '@wix/wix-vod-constants/app-settings';
import { migrateToV1 } from './migrations/version-1';
import { migrateToV2 } from './migrations/version-2';
import { migrateToV3 } from './migrations/version-3';
import { migrateToV4 } from './migrations/version-4';
const migrations = {
  [APP_SETTINGS_VERSION_0]: migrateToV1,
  [APP_SETTINGS_VERSION_1]: migrateToV2,
  [APP_SETTINGS_VERSION_2]: migrateToV3,
  [APP_SETTINGS_VERSION_3]: migrateToV4
};
export function migrateToLatestVersion(appSettings) {
  const version = get(appSettings, 'numbers.settingsVersion', APP_SETTINGS_VERSION_0);
  for (let v = version; v < APP_SETTINGS_VERSION_LATEST; v++) {
    appSettings = migrations[v](appSettings);
  }
  return appSettings;
}
//# sourceMappingURL=migration.js.map